import { downloadData, uploadData } from 'aws-amplify/storage'
import { S3_STORAGE_SCOPE } from '@/config/portalEnvironment'
import { buildAmplifyBucketOptions } from '@/utils/s3Storage'

/**
 * Upload a context file using the exact s3_key and kb_upload_metadata
 * returned by createContext / updateContext (when files were sent).
 * Do not invent paths or alter metadata keys.
 */
export async function uploadContextS3Object({
  s3Key,
  data,
  contentType,
  metadata = {},
}) {
  const path = String(s3Key ?? '').trim()
  if (!path) {
    throw new Error('Context upload path (s3_key) is missing.')
  }

  const normalizedMetadata = Object.fromEntries(
    Object.entries(metadata ?? {})
      .filter(([, value]) => value != null && String(value).trim())
      .map(([key, value]) => [key, String(value)]),
  )

  await uploadData({
    path,
    data,
    options: {
      contentType: contentType || undefined,
      ...(Object.keys(normalizedMetadata).length
        ? { metadata: normalizedMetadata }
        : {}),
      ...buildAmplifyBucketOptions(S3_STORAGE_SCOPE.KNOWLEDGE_BASE),
    },
  }).result

  return { s3_key: path }
}

/**
 * Download an existing context file's text from the KB bucket using its s3_key.
 */
export async function downloadContextS3Text(s3Key) {
  const path = String(s3Key ?? '').trim()
  if (!path) {
    throw new Error('Context file path (s3_key) is missing.')
  }

  const { body } = await downloadData({
    path,
    options: {
      ...buildAmplifyBucketOptions(S3_STORAGE_SCOPE.KNOWLEDGE_BASE),
    },
  }).result

  const blob = await body.blob()
  if (!blob?.size) return ''
  return blob.text()
}
